<template>
  <div>
    <v-container>
      <DateFilter
        class="mb-4"
        v-model="selectedDate"
        @changeDate="getsahapanpointdetailall"
        :default-filter="'last_7_days'"
        :showTime="true"
      ></DateFilter>
      <div>
        <v-select
          width="40%"
          single-line
          outline
          v-model="status"
          :items="options"
          @change="onSelected"
        ></v-select>
        <v-card v-for="(item, k) in data" :key="item.id" class="mb-2">
          <v-card-text>
            <div class="text-xs-right caption">
              {{ item.point_timestamp | DateFormat('DD/MM/YYYY') }}
            </div>
            <v-layout>
              <v-flex xs4 class="pr-3">
                <div class="grey lighten-4 text-xs-center">
                  <a rel="noopener noreferrer" target="_blank" :href="item.photourl">
                    <img
                      v-if="item.photourl"
                      style="object-fit: contain; border-radius: 5px; width: 160px; height: 160px"
                      :src="item.photourl"
                      alt
                    />
                    <img
                      v-else
                      style="object-fit: contain; border-radius: 5px; width: 160px; height: 160px"
                      src="/static/img/empty-img-placeholder.png"
                      alt
                    />
                  </a>
                </div>
              </v-flex>
              <v-flex xs8>
                <div style="line-height: 2em">
                  <div style="font-weight: 600; color: grey">
                    เลขที่ใบสั่งซื้อ
                    <a>{{ item.receipt_no }}</a>
                  </div>
                  <div>ชื่อ: {{ item.realname ? item.realname : '-' }}</div>
                  <div>Line: {{ item.line_name ? item.line_name : '-' }}</div>
                  <div>
                    สถานะ:
                    <v-chip
                      color="green"
                      text-color="white"
                      v-if="item.status == 'approve'"
                      class="ma-2"
                      >{{ item.status }}</v-chip
                    >
                    <v-chip
                      color="red"
                      text-color="white"
                      v-else-if="item.status == 'reject'"
                      class="ma-2"
                      >{{ item.status }}</v-chip
                    >
                    <v-chip text-color="white" v-else class="ma-2">review</v-chip>
                  </div>
                  <div>สถานที่: {{ item.place }}</div>
                  <div class="text-xs-right">
                    <v-btn
                      :disabled="item.status == 'approve'"
                      :loading="loading"
                      @click="approveStatus('approve', item, k)"
                      style="color: white"
                      color="green"
                      >Approve</v-btn
                    >
                    <v-btn
                      :loading="loading"
                      style="color: white"
                      :disabled="item.status == 'reject'"
                      @click="approveStatus('reject', item, k)"
                      color="red"
                      >Reject</v-btn
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-content>
                <template v-slot:actions>
                  <v-icon color="primary">$vuetify.icons.expand</v-icon>
                </template>
                <template v-slot:header>
                  <div>รายการสินค้า</div>
                </template>
                <v-data-table
                  :loading="loading"
                  v-bind:pagination.sync="pagination"
                  :headers="headers"
                  :items="JSON.parse(item.productlist)"
                >
                  <template v-slot:items="props">
                    <td class="text-xs">{{ props.item.name }}</td>
                    <td class="text-xs">{{ props.item.quantity }}</td>
                    <td class="text-xx">{{ props.item.total }}</td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
    <v-dialog v-model="showaddpoint" persistent width="500">
      <v-card>
        <v-card-text>
          <div class="form-control">
            <label>จำนวน Point</label>
            <input type="text" v-model="pointinput" />
          </div>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="showaddpoint = false">Cancel</v-btn>
            <v-btn
              :loading="loading"
              color="primary"
              depressed
              @click="changestatus(addpointdata.type, addpointdata.item, addpointdata.k)"
              >Approve</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      status: 'review',
      loading: false,
      pointinput: 0,
      showaddpoint: false,
      addpointdata: {
        type: '',
        item: {},
        k: ''
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      },
      headers: [
        { text: 'ชื่อสินค้า', value: 'name' },
        { text: 'จำนวน', value: 'quantity' },
        { text: 'ราคารวม', value: 'total' }
      ],
      data: [],
      data2: [],
      options: ['all', 'review', 'reject', 'approve']
    }
  },
  components: {
    DateFilter
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getsahapanpointdetailall()
  },
  methods: {
    onSelected(v) {
      this.status = v
      this.getsahapanpointdetailall()
    },
    approveStatus(type, item, k) {
      this.pointinput = 0
      this.addpointdata = {
        type,
        item,
        k
      }
      this.showaddpoint = true
    },
    changestatus(type, item, k) {
      var vm = this
      vm.loading = true
      var data = {
        id: item.id,
        status: type,
        point: item.point,
        userid: item.userid
      }

      Object.assign(data, { point: parseFloat(this.pointinput) })

      api.putsahapanupdatepoint(data, (err, response) => {
        vm.loading = false
        if (response.responsecode == 200) {
          item.status = type
          this.showaddpoint = false
        }
      })
    },
    getsahapanpointdetailall() {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        status: this.status,
        startdate: this.selectedDate.start,
        enddate: this.selectedDate.end
      }
      api.getsahapanpointdetailall(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.data = response.data
          vm.data2 = response.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/sahapan/ApprovePoint.vue